// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, Filter, Download, Calendar, ArrowUpRight, CreditCard } from 'lucide-react';
// import * as XLSX from 'xlsx';
// import { toast } from 'react-toastify';
// import '../../Dashboard Style/WalletTransaction.css'; // Reusing your existing CSS

// const TeamIncome = ({ title, incomeType }) => {
//   const authToken = useSelector((state) => state.user?.token);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [perPage, setPerPage] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [originalTransactions, setOriginalTransactions] = useState([]);
  

//   const toggleSidebar = () => {
//       setSidebarOpen(!sidebarOpen);
//     };
  
//     // Initialize sidebar functionality (same as in Dashboard)
//     useEffect(() => {
//       const sidebar = document.querySelector('.sidebar');
//       const sidebarBody = document.querySelector('.sidebar-body');
      
//       if (sidebar) {
//         if (sidebarOpen) {
//           sidebar.classList.remove('close');
//         } else {
//           sidebar.classList.add('close');
//         }
//       }
      
//       // Add custom scrollbar to sidebar body
//       if (sidebarBody) {
//         sidebarBody.style.height = 'calc(100vh - 70px)';
//         sidebarBody.style.overflowY = 'auto';
//       }
  
//       return () => {
//         // Cleanup
//       };
//     }, [sidebarOpen]);
  
//     useEffect(() => {
//       // Add custom scrollbar styles for sidebar
//       const style = document.createElement('style');
//       style.innerHTML = `
//         /* Custom scrollbar for sidebar */
//         .sidebar-body {
//           height: calc(100vh - 70px);
//           overflow-y: auto;
//         }
        
//         .sidebar-body::-webkit-scrollbar {
//           width: 6px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb {
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb:hover {
//           background: rgba(255, 255, 255, 0.3);
//         }
        
//         /* Sidebar dropdown menu styles */
//         .sidebar .nav-dropdown {
//           list-style: none;
//           padding-left: 0;
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//         }
        
//         .sidebar .nav-dropdown.show {
//           max-height: 500px;
//         }
        
//         .sidebar .nav-dropdown-item {
//           padding-left: 2.5rem;
//         }
        
//         /* Sidebar dropdown toggle with icon */
//         .nav-item.has-dropdown .nav-link {
//           position: relative;
//           padding-right: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .dropdown-icon {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           transition: transform 0.3s ease;
//         }
        
//         .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//           transform: translateY(-50%) rotate(180deg);
//         }
        
//         /* Improved dropdown styling similar to first image */
//         .nav-item.has-dropdown .nav-dropdown {
//           background: rgba(255, 255, 255, 0.05);
//           border-left: 3px solid var(--primary-color, #0d6efd);
//           margin-left: 1rem;
//           border-radius: 0 0 8px 8px;
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//           padding: 0.75rem 1rem 0.75rem 2rem;
//           color: rgba(255, 255, 255, 0.8);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//           background: rgba(255, 255, 255, 0.1);
//           color: white;
//         }
        
//         /* Fix for category text styling */
//         .nav-item.has-dropdown .link-title.nav-item.nav-category {
//           font-weight: 600;
//           font-size: 0.875rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
        
//         /* Smooth transitions */
//         .sidebar {
//           transition: all 0.3s ease;
//         }
//       `;
//       document.head.appendChild(style);
  
//       return () => {
//         document.head.removeChild(style);
//       };
//     }, []);

//   const fetchIncomeData = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/get-wallet-transaction`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({
//           wallet_type: incomeType, // Dynamic based on route
//           per_page: perPage.toString(),
//           page: currentPage.toString()
//         })
//       });

//       const data = await response.json();
//       if (data.status) {
//         setTransactions(data.data || []);
//         setTotalPages(data.pagination?.last_page || 1);
//       } else {
//         toast.error(data.message || `Failed to fetch ${title}`);
//       }
//     } catch (error) {
//       toast.error("Connection Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//     const handleDateFilterChange = (filter) => {
//       setDateFilter(filter);
//       setCurrentPage(1);
//       toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
//     };

//       const handleSearch = (e) => {
//     e.preventDefault();
//     // Search is handled by filteredTransactions memo
//   };

//    const filteredTransactions = useMemo(() => {
//       let filtered = [...originalTransactions];
  
//       // Apply search filter
//       if (searchQuery.trim()) {
//         const query = searchQuery.toLowerCase();
//         filtered = filtered.filter(transaction => 
//           transaction.transaction_id?.toString().toLowerCase().includes(query) ||
//           transaction.from_user_email?.toLowerCase().includes(query) ||
//           transaction.transaction_type?.toLowerCase().includes(query) ||
//           transaction.opening_bal?.toString().includes(query) ||
//           transaction.credit_bal?.toString().includes(query) ||
//           transaction.debit_bal?.toString().includes(query) ||
//           transaction.closing_bal?.toString().includes(query)
//         );
//       }
  
//       // Apply date filter
//       if (dateFilter !== 'all') {
//         const now = new Date();
//         filtered = filtered.filter(transaction => {
//           const transactionDate = new Date(transaction.created_at);
          
//           switch (dateFilter) {
//             case 'today':
//               return transactionDate.toDateString() === now.toDateString();
            
//             case 'week': {
//               const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//               return transactionDate >= oneWeekAgo;
//             }
            
//             case 'month': {
//               const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
//               return transactionDate >= oneMonthAgo;
//             }
            
//             case 'year': {
//               const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
//               return transactionDate >= oneYearAgo;
//             }
            
//             default:
//               return true;
//           }
//         });
//       }
  
//       return filtered;
//     }, [originalTransactions, searchQuery, dateFilter]);
  

//   useEffect(() => { fetchIncomeData(); }, [currentPage, perPage, incomeType]);

//   const filteredData = useMemo(() => {
//     let filtered = [...transactions];
//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase();
//       filtered = filtered.filter(t => t.transaction_id?.toString().includes(q) || t.from_user_email?.toLowerCase().includes(q));
//     }
//     return filtered;
//   }, [transactions, searchQuery]);

//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Report');
//     XLSX.writeFile(wb, `${title}_Report.xlsx`);
//     toast.success("Report Exported");
//   };

//   return (
//       <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />
//         <div className="page-content p-4">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <h3 className="text-white">{title}</h3>
//           </div>

//          <div className="row mb-4">
//                       <div className="col-md-8">
//                         <div className="d-flex gap-3 search-filter">
//                           <form onSubmit={handleSearch} className="flex-grow-1">
//                             <div className="search-box">
//                               <Search size={18} className="search-icon" />
//                               <input
//                                 type="text"
//                                 className="search-input"
//                                 placeholder="Search by transaction ID, email, or amount..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                               {/* <button type="submit" className="search-btn">
//                                 Search
//                               </button> */}
//                             </div>
//                           </form>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               <Filter size={16} className="me-2" />
//                               {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
//                             </button>
//                             <div className="dropdown-menu">
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('today')}
//                               >
//                                 Today
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('week')}
//                               >
//                                 This Week
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('month')}
//                               >
//                                 This Month
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('year')}
//                               >
//                                 This Year
//                               </button>
//                               <div className="dropdown-divider"></div>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('all')}
//                               >
//                                 All Time
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className="d-flex export-page gap-2">
//                           <button 
//                             className="btn btn-outline-light"
//                             onClick={handleDownload}
//                             disabled={filteredTransactions.length === 0}
//                           >
//                             <Download size={16} className="me-2" />
//                             Export ({filteredTransactions.length})
//                           </button>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               {perPage} per page
//                             </button>
//                             <div className="dropdown-menu">
//                               {[10, 15, 25, 50, 100].map((num) => (
//                                 <button
//                                   key={num}
//                                   className={`dropdown-item ${perPage === num ? 'active' : ''}`}
//                                   onClick={() => {
//                                     setPerPage(num);
//                                     toast.info(`Displaying ${num} transactions per page`);
//                                   }}
//                                 >
//                                   {num} per page
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//           <div className="transaction-table-wrapper">
//             {loading ? (
//               <div className="text-center py-5"><div className="spinner-border text-light"></div></div>
//             ) : (
//               <div className="table-responsive">
//                 <table className="transaction-table">
//                   <thead>
//                     <tr>
//                       <th>Transaction ID</th>
//                       <th>Type</th>
//                       <th>From/To</th>
//                       <th>Opening</th>
//                       <th>Amount</th>
//                       <th>Closing</th>
//                       <th>Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredData.map((t) => (
//                       <tr key={t.id}>
//                         <td>#{t.transaction_id}</td>
//                         <td className="text-info"><CreditCard size={14} className="me-1"/> {t.transaction_type}</td>
//                         <td>{t.from_user_email || 'System'}</td>
//                         <td>${parseFloat(t.opening_bal).toFixed(2)}</td>
//                         <td className={t.credit_bal > 0 ? "text-green" : "text-red"}>
//                             {t.credit_bal > 0 ? `+$${t.credit_bal}` : `-$${t.debit_bal}`}
//                         </td>
//                         <td>${parseFloat(t.closing_bal).toFixed(2)}</td>
//                         <td><Calendar size={14}/> {new Date(t.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>
//          <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0 text-white">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default TeamIncome;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, Filter, Download, ChevronLeft, ChevronRight, User, DollarSign, Percent, Clock, Users } from 'lucide-react';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../../Dashboard Style/WalletTransaction.css';
import { getTeamIncomeListApi } from '../../Services/Operations/ProductAPI'; // Import the new API

const TeamIncome = ({ title, incomeType }) => {
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalCommission, setTotalCommission] = useState(0);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);
  
  useEffect(() => {
    // Add custom styles for Team Income page
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Team Income specific styles */
      .team-level-badge {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 6px 15px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 700;
        display: inline-block;
        letter-spacing: 1px;
      }
      
      .user-details-team {
        background: rgba(255, 255, 255, 0.03);
        border-radius: 8px;
        padding: 12px;
        border-left: 3px solid #9c27b0;
      }
      
      .position-badge-team {
        background: rgba(156, 39, 176, 0.2);
        color: #9c27b0;
        padding: 3px 10px;
        border-radius: 15px;
        font-size: 11px;
        font-weight: 600;
      }
      
      .amount-value-team {
        font-weight: 700;
        font-size: 16px;
        color: #4caf50;
      }
      
      .commission-percentage-team {
        font-weight: 600;
        font-size: 15px;
        color: #2196f3;
      }
      
      .commission-amount-team {
        font-weight: 700;
        font-size: 16px;
        color: #ff9800;
      }
      
      /* Table styles */
      .team-income-table {
        background: rgba(30, 30, 40, 0.8);
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      }
      
      .team-income-table thead th {
        background: linear-gradient(135deg, rgba(156, 39, 176, 0.2) 0%, rgba(102, 126, 234, 0.2) 100%);
        color: #e9ecef;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.8px;
        padding: 18px 15px;
        border-bottom: 2px solid rgba(156, 39, 176, 0.4);
        position: relative;
      }
      
      .team-income-table thead th:after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #9c27b0, #667eea);
      }
      
      .team-income-table tbody td {
        padding: 16px 15px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        color: #e9ecef;
        background: rgba(40, 40, 50, 0.5);
        transition: all 0.3s ease;
      }
      
      .team-income-table tbody tr:nth-child(even) td {
        background: rgba(35, 35, 45, 0.5);
      }
      
      .team-income-table tbody tr:hover td {
        background: rgba(50, 50, 65, 0.7);
        transform: scale(1.005);
      }
      
      /* SL. NO. styling */
      .sl-no-circle-team {
        background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%);
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 14px;
        box-shadow: 0 4px 8px rgba(156, 39, 176, 0.3);
      }
      
      /* Pagination styles */
      .pagination-container-team {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: rgba(30, 30, 40, 0.8);
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        margin-top: 20px;
      }
      
      .pagination-info-team {
        color: #adb5bd;
        font-size: 14px;
        font-weight: 500;
      }
      
      .pagination-buttons-team .btn {
        margin: 0 4px;
        min-width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        transition: all 0.3s ease;
      }
      
      .pagination-buttons-team .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
      
      .page-numbers-team {
        display: flex;
        gap: 5px;
      }
      
      /* Summary cards for team */
      .summary-card-team {
        background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
        border-radius: 12px;
        padding: 25px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      }
      
      .summary-card-team:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
      }
      
      .summary-card-team.income-team:before {
        background: linear-gradient(90deg, #4caf50, #8bc34a);
      }
      
      .summary-card-team.commission-team:before {
        background: linear-gradient(90deg, #ff9800, #ffc107);
      }
      
      .summary-card-team.transactions-team:before {
        background: linear-gradient(90deg, #2196f3, #03a9f4);
      }
      
      .summary-card-team:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
      }
      
      /* Search box styles */
      .search-box-team {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
        padding: 12px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
      }
      
      .search-box-team:focus-within {
        border-color: #9c27b0;
        box-shadow: 0 0 0 3px rgba(156, 39, 176, 0.2);
      }
      
      .search-box-team input {
        background: transparent;
        border: none;
        color: white;
        flex: 1;
        padding: 0 15px;
        outline: none;
        font-size: 14px;
      }
      
      .search-box-team input::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      
      /* Icon containers */
      .icon-circle-team {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        font-size: 22px;
      }
      
      .icon-circle-team.income {
        background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.2));
        color: #4caf50;
      }
      
      .icon-circle-team.commission {
        background: linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 193, 7, 0.2));
        color: #ff9800;
      }
      
      .icon-circle-team.transactions {
        background: linear-gradient(135deg, rgba(33, 150, 243, 0.2), rgba(3, 169, 244, 0.2));
        color: #2196f3;
      }
      
      /* Text colors */
      .text-income-team { color: #4caf50 !important; }
      .text-commission-team { color: #ff9800 !important; }
      .text-team-primary { color: #9c27b0 !important; }
      .text-team-secondary { color: #2196f3 !important; }
    `;
    document.head.appendChild(style);
    
    // Fetch data on component mount
    fetchTeamIncome();

    return () => {
      document.head.removeChild(style);
    };
  }, [currentPage, perPage]);

    useEffect(() => {
      const sidebar = document.querySelector('.sidebar');
      const sidebarBody = document.querySelector('.sidebar-body');
      
      if (sidebar) {
        if (sidebarOpen) {
          sidebar.classList.remove('close');
        } else {
          sidebar.classList.add('close');
        }
      }
      
      if (sidebarBody) {
        sidebarBody.style.height = 'calc(100vh - 70px)';
        sidebarBody.style.overflowY = 'auto';
      }
  
      return () => {};
    }, [sidebarOpen]);
  
    useEffect(() => {
      const style = document.createElement('style');
      style.innerHTML = `
        .sidebar-body {
          height: calc(100vh - 70px);
          overflow-y: auto;
        }
        
        .sidebar-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .sidebar-body::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 10px;
        }
        
        .sidebar-body::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        .sidebar .nav-dropdown {
          list-style: none;
          padding-left: 0;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }
        
        .sidebar .nav-dropdown.show {
          max-height: 500px;
        }
        
        .sidebar .nav-dropdown-item {
          padding-left: 2.5rem;
        }
        
        .nav-item.has-dropdown .nav-link {
          position: relative;
          padding-right: 2.5rem;
        }
        
        .nav-item.has-dropdown .dropdown-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.3s ease;
        }
        
        .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
          transform: translateY(-50%) rotate(180deg);
        }
        
        .nav-item.has-dropdown .nav-dropdown {
          background: rgba(255, 255, 255, 0.05);
          border-left: 3px solid var(--primary-color, #0d6efd);
          margin-left: 1rem;
          border-radius: 0 0 8px 8px;
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link {
          padding: 0.75rem 1rem 0.75rem 2rem;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
        }
        
        .nav-item.has-dropdown .link-title.nav-item.nav-category {
          font-weight: 600;
          font-size: 0.875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .sidebar {
          transition: all 0.3s ease;
        }
      `;
      document.head.appendChild(style);
  
      return () => {
        document.head.removeChild(style);
      };
    }, []);
  
  const fetchTeamIncome = async () => {
    try {
      setLoading(true);
      const result = await getTeamIncomeListApi(authToken, currentPage, perPage);
      
      if (result.status) {
        setTransactions(result.data);
        setTotalPages(result.pagination.last_page || 1);
        
        // Calculate totals
        const incomeTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.amount_value) || 0), 0);
        const commissionTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.commission_amount) || 0), 0);
        
        setTotalIncome(incomeTotal);
        setTotalCommission(commissionTotal);
        
        // toast.success(result.message || 'Team income loaded successfully');
      } else {
        toast.error(result.message || 'Failed to load team income');
      }
    } catch (error) {
      console.error('Error fetching team income:', error);
      toast.error('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by filteredTransactions memo
  };
  
  const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1);
    toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
  };
  
  const filteredTransactions = useMemo(() => {
    let filtered = [...transactions];
    
    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(transaction => 
        transaction.from_user_email?.toLowerCase().includes(query) ||
        transaction.from_user_account_name?.toLowerCase().includes(query) ||
        transaction.level?.toLowerCase().includes(query) ||
        transaction.amount_value?.toString().includes(query) ||
        transaction.commission_amount?.toString().includes(query)
      );
    }
    
    // Apply date filter
    if (dateFilter !== 'all') {
      const now = new Date();
      filtered = filtered.filter(transaction => {
        const transactionDate = new Date(transaction.created_at);
        
        switch (dateFilter) {
          case 'today':
            return transactionDate.toDateString() === now.toDateString();
          case 'week': {
            const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            return transactionDate >= oneWeekAgo;
          }
          case 'month': {
            const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            return transactionDate >= oneMonthAgo;
          }
          case 'year': {
            const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            return transactionDate >= oneYearAgo;
          }
          default:
            return true;
        }
      });
    }
    
    return filtered;
  }, [transactions, searchQuery, dateFilter]);
  
 const handleDownload = () => {
  if (filteredTransactions.length === 0) {
    toast.warning('No data to export');
    return;
  }
  
  const exportData = filteredTransactions.map((item, index) => ({
    'SL No': (currentPage - 1) * perPage + index + 1,
    'Level': item.level,
    'User Email': item.from_user_email,
    'Account Name': item.from_user_account_name,
    'Amount Value': `$${parseFloat(item.amount_value || 0).toFixed(2)}`,
    'Commission %': `${item.commission_percentage}%`,
    'Commission Amount': `$${parseFloat(item.commission_amount || 0).toFixed(2)}`,
    'Status': item.status, // Add status
    'Description': item.description, // Add description
    'Created At': item.created_at
  }));
  
  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Team Income');
  XLSX.writeFile(wb, `Team_Income_${new Date().toISOString().split('T')[0]}.xlsx`);
  toast.success('Team income report exported successfully!');
};
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
  
  // Get position indicator
  const getPositionIndicator = (transaction) => {
    if (transaction.position) {
      return transaction.position;
    }
    const positions = ['L', 'R'];
    return positions[transaction.id % 2];
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pageNumbers.push(i);
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pageNumbers.push(i);
        }
      }
    }
    
    return pageNumbers;
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                   isOpen={!sidebarOpen}
                   onClose={closeSidebar}
                 />
       
                 {/* Mobile backdrop */}
                 {isMobile && sidebarOpen && (
                   <div
                     className="sidebar-backdrop"
                     onClick={closeSidebar}
                   />
                 )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
            isMobile={isMobile}/>

        
        <div className="page-content p-4">
          {/* Page Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="text-white fw-bold mb-1">{title}</h3>
              <p className="text-muted mb-0">Track your team income and commissions across all levels</p>
            </div>
            <div>
              <span className="badge bg-gradient-team px-3 py-2">
                <Users size={16} className="me-2" />
                Team Network
              </span>
            </div>
          </div>
          
          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-4">
              <div className="summary-card-team income-team">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-team income">
                    <DollarSign size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Team Income</h6>
                    <h3 className="text-white mb-0 text-income-team">${totalIncome.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card-team commission-team">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-team commission">
                    <Percent size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Commission</h6>
                    <h3 className="text-white mb-0 text-commission-team">${totalCommission.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card-team transactions-team">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-team transactions">
                    <Users size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Team Transactions</h6>
                    <h3 className="text-white mb-0">{filteredTransactions.length}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Search and Filter Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <div className="d-flex gap-3">
                <form onSubmit={handleSearch} className="flex-grow-1">
                  <div className="search-box-team">
                    <Search size={18} className="text-muted me-2" />
                    <input
                      type="text"
                      placeholder="Search by email, account name, or level..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </form>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Filter size={16} className="me-2" />
                    {dateFilter === 'all' ? 'All Time' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                  </button>
                  <div className="dropdown-menu">
                    <button 
                      className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('today')}
                    >
                      Today
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('week')}
                    >
                      This Week
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('month')}
                    >
                      This Month
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('year')}
                    >
                      This Year
                    </button>
                    <div className="dropdown-divider"></div>
                    <button 
                      className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('all')}
                    >
                      All Time
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  className="btn btn-outline-light"
                  onClick={handleDownload}
                  disabled={filteredTransactions.length === 0}
                >
                  <Download size={16} className="me-2" />
                  Export ({filteredTransactions.length})
                </button>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {perPage} per page
                  </button>
                  <div className="dropdown-menu">
                    {[10, 15, 25, 50, 100].map((num) => (
                      <button
                        key={num}
                        className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                        onClick={() => {
                          setPerPage(num);
                          setCurrentPage(1);
                          toast.info(`Displaying ${num} records per page`);
                        }}
                      >
                        {num} per page
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Table Section */}
          <div className="team-income-table">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-team-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-white">Loading team income data...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                 <thead>
  <tr>
    <th>SL. NO.</th>
    <th>LEVEL</th>
    <th>USER DETAILS</th>
    <th>AMOUNT VALUE</th>
    <th>MY COMMISSION (%)</th>
    <th>MY COMMISSION ($)</th>
    <th>STATUS</th>
    <th>DESCRIPTION</th>
    <th>TIMESTAMP</th>
  </tr>
</thead>
          <tbody>
  {filteredTransactions.length === 0 ? (
    <tr>
      <td colSpan="9" className="text-center py-5">
        <div className="text-muted">
          <Users size={48} className="mb-3 opacity-50 text-team-primary" />
          <h5 className="text-white">No team income found</h5>
          <p className="text-muted mb-0">Build your team to start earning team income</p>
        </div>
      </td>
    </tr>
  ) : (
    filteredTransactions.map((transaction, index) => (
      <tr key={transaction.id} className="border-bottom border-dark">
        {/* SL. NO. */}
        <td className="align-middle">
          <div className="d-flex align-items-center">
            <div className="sl-no-circle-team">
              {(currentPage - 1) * perPage + index + 1}
            </div>
          </div>
        </td>
        
        {/* LEVEL */}
        <td className="align-middle">
          <span className="team-level-badge">
            {transaction.level}
          </span>
        </td>
        
        {/* USER DETAILS */}
        <td className="align-middle">
          <div className="user-details-team">
            <div className="d-flex align-items-center mb-2">
              <div className="bg-team-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" 
                   style={{ width: '40px', height: '40px' }}>
                <User size={20} className="text-team-primary" />
              </div>
              <div>
                <div className="text-white fw-bold fs-6">{transaction.from_user_account_name}</div>
                <div className="small text-muted">{transaction.from_user_email}</div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <span className="position-badge-team">
                Position: {getPositionIndicator(transaction)}
              </span>
            </div>
          </div>
        </td>
        
        {/* AMOUNT VALUE */}
        <td className="align-middle">
          <div className="d-flex align-items-center">
            <div>
              <div className="amount-value-team">${parseFloat(transaction.amount_value || 0).toFixed(2)}</div>
            </div>
          </div>
        </td>
        
        {/* MY COMMISSION (%) */}
        <td className="align-middle">
          <div className="bg-team-secondary bg-opacity-10 p-3 rounded-3 text-center">
            <div className="commission-percentage-team">{transaction.commission_percentage}%</div>
          </div>
        </td>
        
        {/* MY COMMISSION ($) */}
        <td className="align-middle">
          <div className="bg-warning bg-opacity-10 p-3 rounded-3 text-center">
            <div className="commission-amount-team" style={{color:"black"}}>${parseFloat(transaction.commission_amount || 0).toFixed(2)}</div>
          </div>
        </td>
        
        {/* STATUS */}
        <td className="align-middle">
          <div className={`${transaction.status === 'CREDITED' ? 'bg-success' : 'bg-danger'} bg-opacity-10 p-3 rounded-3 text-center`}>
            <div className={`${transaction.status === 'CREDITED' ? '' : 'text-danger'} fw-bold`}>
              {transaction.status}
            </div>
          </div>
        </td>
        
        {/* DESCRIPTION */}
        <td className="align-middle">
          <div className="bg-dark bg-opacity-50 p-3 rounded-3">
            <div className="text-white small fw-medium">{transaction.description}</div>
          </div>
        </td>
        
        {/* TIMESTAMP */}
        <td className="align-middle">
          <div className="bg-dark p-3 rounded-3">
            <div className="text-white small">
              <Clock size={14} className="me-2 text-muted" />
              {formatDate(transaction.created_at)}
            </div>
          </div>
        </td>
      </tr>
    ))
  )}
</tbody>
                </table>
              </div>
            )}
          </div>
          
          {/* Pagination */}
          {!loading && filteredTransactions.length > 0 && (
            <div className="pagination-container-team">
              <div className="pagination-info-team">
                Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, filteredTransactions.length)} of {filteredTransactions.length} entries
              </div>
              <div className="pagination-buttons-team">
                <button
                  className="btn btn-outline-light"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} /> Prev
                </button>
                
                <div className="page-numbers-team d-inline-block mx-2">
                  {getPageNumbers().map((pageNum) => (
                    <button
                      key={pageNum}
                      className={`btn ${currentPage === pageNum ? 'btn-team-primary' : 'btn-outline-light'}`}
                      onClick={() => handlePageClick(pageNum)}
                    >
                      {pageNum}
                    </button>
                  ))}
                  
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <>
                      <span className="mx-2 text-muted">...</span>
                      <button
                        className="btn btn-outline-light"
                        onClick={() => handlePageClick(totalPages)}
                      >
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>
                
                <button
                  className="btn btn-outline-light"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default TeamIncome;